<template>
  <div v-if="hasBanners"
    class="category-banners"
  >
    <h2 class="category-banners__title">
      Да, это мне подходит
    </h2>
    <div class="category-banners__inner">
      <banner
        v-for="banner in BANNERS"
        :key="banner.id"
        :data="banner"
        :slot-name="slotName"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Banner from '@/components/banner/banner.vue';

export default {
  name: 'category-banners',

  components: { Banner },

  props: {
    slotName: {
      type: String,
      required: true,
    },
    withCategory: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    BANNERS() {
      return this.$store.state.banners[this.slotName] || []
    },
    hasBanners() {
      return !!this.BANNERS.length;
    },
  },

  methods: {
    ...mapActions('banners', ['getBanners']),
  },

  serverPrefetch() {
    return this.getBanners({ slots: [this.slotName], withCategory: this.withCategory });
  },
};
</script>

<style lang="scss">
.category-banners {
  &__inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include breakpoint("tablet") {
      flex-wrap: nowrap;
    }
  }

  .banner {
    flex: 0 1 calc(50% - 8px);
    margin-bottom: 16px;

    @include breakpoint("tablet") {
      flex: 0 1 calc(25% - 12px);
    }

    @include breakpoint("desktop") {
      flex: 0 1 calc(25% - 18px);
    }
  }

  &__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 300;
    margin-bottom: 24px;

    @include breakpoint("desktop") {
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 32px;
    }
  }
}
</style>
